import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../auth/components/services/auth.service';

@Injectable()
export class ApiInterceptorService implements HttpInterceptor {
    private readonly authService = inject(AuthService);

    intercept(httpRequest: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!httpRequest.url.startsWith('http')) {
            const apiReq = httpRequest.clone({
                url: `${environment.api}/${httpRequest.url}`,
                setHeaders: { 'cache-control': 'no-cache' },
            });
            return next.handle(apiReq).pipe(
                catchError((e) => {
                    if (e instanceof HttpErrorResponse && e.status === 401) {
                        this.authService.logout();
                        return EMPTY;
                    }
                    throw e;
                }),
            );
        }
        return next.handle(httpRequest);
    }
}
